export default {
  StickyClass: {
    mounted() {
      const stickyClass = this.el.dataset.stickyClass;

      const rootMargin = this.el.dataset.stickyRootMargin || '0px';
      this.observer = new IntersectionObserver(
        ([e]) => {
          e.target.classList.toggle(stickyClass, e.intersectionRatio < 1);
        },
        { threshold: [1], rootMargin },
      );

      this.observer.observe(this.el);
    },

    destroyed() {
      this.observer?.disconnect();
    },
  },
};
